<template>
  <market-report-settings v-if="!loading" :report="report" @submit="submit" />
  <q-inner-loading v-else showing color="secondary" />
</template>

<script lang="ts">
import type { MarketReportSubscriptionAttributes } from 'common'
import { useMarketReportStore } from '@/stores/marketreport'
import MarketReportSettings from '@/components/MarketReports/MarketReportSettings.vue'
import { useUserStore } from '@/stores/user'

export default {
  name: 'MarketReportNewView',
  components: {
    MarketReportSettings
  },
  data() {
    return {
      loading: false,
      report: {
        id: -1,
        name: '',
        filters: {
          coordinates: [],
          year_built: { min: null, max: null },
          number_units: { min: null, max: null },
          number_stories: { min: null, max: null }
        },
        user_id: useUserStore().user!.sub,
        modified_on: new Date().toISOString(),
        created_on: new Date().toISOString(),
        deleted_on: null
      } as MarketReportSubscriptionAttributes
    }
  },
  methods: {
    submit(report: MarketReportSubscriptionAttributes) {
      useMarketReportStore()
        .create(report)
        .then((report) => {
          if (report) {
            this.$tracker.createdReport(report.id, 'new', 'market')
            this.$router.push({ name: 'Regional Report', params: { reportId: report.id } })
          } else {
            this.$router.push({ name: 'Regional Reports' })
          }
        })
    }
  }
}
</script>
